import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "map",
    standalone: false
})
export class MapPipe implements PipeTransform {
  transform(arr: any[], prop: string): any[] {
    return arr.map((item) => item[prop]);
  }
}
